import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const { pathname } = useLocation();

  let quote = " 'You miss 100% of the shots you don't take. - Wayne Gretzky'";
  quote += " - Michael Scott";

  if (pathname === "/contact") {
    quote = "You're driving with the Driving Crooner, baby";
    quote += " - Tim Robinson";
  } else if (pathname === "/privacy-policy") {
    quote = "If you ain't first you're last.";
    quote += " - Ricky Bobby";
  } else if (pathname === "/resources") {
    quote = "Fool me once, strike one. Fool me twice... strike three.";
    quote += " - Michael Scott";
  } else if (pathname === "/about") {
    quote =
      "Moon River Rock — Moon River Roll — Moon River Dance — Run Through My Soul";
    quote += " - Tim Robinson";
  } else if (pathname === "/services") {
    quote =
      "You Walk By A Store And You See 50 Guys Who Look Just Like Me Fighting Over Very Complicated Shirts, You Go In.";
    quote += " - Dan Flashes";
  } else if (
    pathname.startsWith("/blog/") ||
    pathname.startsWith("/content/")
  ) {
    quote =
      "Leslie I typed your symptoms in here and it says you could have network connectivity problems.";
    quote += " - Andy Dwyer";
  }

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-header">
          <h3 className="footer-logo">attoli</h3>
          <p className="footer-quote">"{quote}"</p>
          <p className="footer-description">
            Attoli is an Ottawa-based Website growth and management company
            helping finance businesses across Canada create visibility, connect
            with customers, and grow online.
          </p>
        </div>

        <div className="footer-links">
          <Link to="/privacy-policy" className="footer-link">
            Privacy & Policy
          </Link>
          <Link to="/contact" className="footer-link">
            Contact
          </Link>
        </div>

        <div className="footer-copyright">
          © 2026 Attoli. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
